export default {
    dialog: {
        buttonOk: '確定',
        buttonCancel: '取消',
    },
    photoBrowser:{
        bannerPhotoBrowser:'關閉'
    },
    productAddedToCartSuccess: "商品已加入購物車"
}